import { useEffect } from 'react';

import { MIN_SEARCH_KEYWORD_LENGTH } from '@/common/common.contants';

/**
 * Subscribes to window keydown. When Enter is pressed and the search query
 * meets the minimum length, calls onSearch(query) and prevents default.
 */
export function useSearchEnterKey(
  searchQuery: string,
  onSearch: (query: string) => void,
  minLength: number = MIN_SEARCH_KEYWORD_LENGTH
): void {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && searchQuery.length >= minLength) {
        event.preventDefault();
        onSearch(searchQuery);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [searchQuery, onSearch, minLength]);
}
